// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__UNhBD","notes":"Notes_notes__3pdlH"};